// import { i18n } from '@/setup/i18n';
import {
  UPDATE_PARTNERS,
  UPDATE_CAMPAIGNS_BY_PARTNER_ID_SHOWROOM_CATALOG,
  UPDATE_CAMPAIGN_SELECTED
} from 'store/actions/catalog';
import { mapArrayCampaignData } from 'helpers/object';

export default {
  [UPDATE_PARTNERS]: (state, partners) => {
    state.partners = partners;
  },

  [UPDATE_CAMPAIGN_SELECTED]: (state, data) => {
    state.selected = data.campaignSelected.campaignDetail
      ? mapArrayCampaignData(data.campaignSelected)
      : data.campaignSelected;
  },

  [UPDATE_CAMPAIGNS_BY_PARTNER_ID_SHOWROOM_CATALOG]: (state, dataCatalog) => {
    if (dataCatalog.campaigns) {
      state.campaignsCatalog = dataCatalog.campaigns.map(campaign =>
        mapArrayCampaignData(campaign)
      );
    } else {
      state.campaignsCatalog = [];
    }
  }
};
